import { type CoreUserAddress, type ParameterID } from '@flecto/types'
import { useDrawer } from '@flecto/ui'

import { AddressDrawer } from '../components/AddressDrawer/AddressDrawer'

type UseAddressDrawerProps = {
  addressId?: ParameterID
  onSuccess?: (address: CoreUserAddress) => void
}

export function useAddressDrawer(props?: UseAddressDrawerProps) {
  return useDrawer(
    <AddressDrawer addressId={props?.addressId} onSuccess={props?.onSuccess} />
  )
}
